<template>
  <div>
    <div class="list-group list-group-flush">
      <div
        class="list-group-item d-flex mb-1 align-items-center"
        v-for="sid in selectedItems"
        :key="sid.olab_id"
      >
        <div v-if="selectedType === 'cart'" class="col-1 m-auto">
          <div
            v-if="
              user.email === sid.creator &&
                selectedCart &&
                sid.olab_id === selectedCart.olab_id
            "
          >
            <button
              type="button"
              class="btn btn-success btn"
              v-on:click="handleSelectCart(sid)"
            >
              <font-awesome-icon icon="check-square" />
            </button>
          </div>
          <div v-else-if="user.email === sid.creator">
            <button
              type="button"
              class="btn btn-info btn-sm"
              v-on:click="handleSelectCart(sid)"
            >
              <font-awesome-icon icon="square" />
            </button>
          </div>
          <div v-else class="col-1 m-auto">
            <!-- NOP -->
          </div>
        </div>
        <div
          v-else-if="!selectedCart && selectedType === 'package'"
          class="col-1 m-auto"
        >
          <div
            v-if="
              user.email === sid.creator &&
                selectedPackage &&
                sid.olab_id === selectedPackage.olab_id
            "
          >
            <button
              type="button"
              class="btn btn-success btn"
              v-on:click="handleSelectPackage(sid)"
            >
              <font-awesome-icon icon="check-square" />
            </button>
          </div>
          <div v-else-if="user.email === sid.creator">
            <button
              type="button"
              class="btn btn-info btn-sm"
              v-on:click="handleSelectPackage(sid)"
            >
              <font-awesome-icon icon="square" />
            </button>
          </div>
          <div v-else class="col-1 m-auto">
            <!-- NOP -->
          </div>
        </div>
        <div
          v-else-if="selectedCart && !cartIsFull && selectedType !== 'cart'"
          class="col-1 m-auto"
        >
          <button
            type="button"
            class="btn btn-info"
            data-toggle="modal"
            data-target="#selectAddItem"
            v-on:click="registerItem(sid)"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="plus" />
          </button>
        </div>
        <div
          v-else-if="
            enablePackageAdd &&
              sid.library_id === selectedPackage.library_id &&
              notInPackage(sid, selectedPackage.comps)
          "
          class="col-1 m-auto"
        >
          <button
            type="button"
            class="btn btn-info"
            data-toggle="modal"
            data-target="#selectAddItem"
            v-on:click="registerItem(sid)"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="plus" />
          </button>
        </div>
        <div v-else class="col-1 m-auto">
          <!-- NOP -->
        </div>

        <div v-if="selectedItem != null" class="modal fade" id="selectAddItem">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  OLAB ID:
                  <span class="text-dark">{{ selectedItem.olab_id }}</span>
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <!-- .modal-header -->
              <div class="modal-body">
                <div class="text-wrap">
                  <span class="font-italic mr-1">Name:</span>
                  <span class="h5 text-dark">{{ selectedItem.name }}</span>
                </div>
                <div
                  v-if="selectedType === 'library_sequence'"
                  class="py-1 text-wrap"
                >
                  <span class="font-italic mr-1">Sequence Origin:</span>
                  <span class="h5 text-dark">{{
                    selectedItem.seq_origin
                  }}</span>
                </div>
                <div
                  v-if="selectedType === 'library_sequence'"
                  class="py-1 text-wrap"
                >
                  <span class="font-italic mr-1">Source:</span>
                  <span class="h5 text-dark">{{ selectedItem.source }}</span>
                </div>
                <div
                  v-if="selectedType === 'library_sequence'"
                  class="py-1 text-wrap"
                >
                  <span class="font-italic mr-1">Creator:</span>
                  <span class="h5 text-dark">{{ selectedItem.creator }}</span>
                </div>
                <div
                  v-if="selectedType === 'library_sequence'"
                  class="py-1 text-wrap"
                >
                  <span class="font-italic mr-1">Library ID:</span>
                  <span class="h5 text-dark">{{ printLibraryInfo }}</span>
                </div>
                <div v-if="selectedType === 'package'" class="py-1 text-wrap">
                  <span class="font-italic mr-1">Package Type:</span>
                  <span class="h5 text-dark"
                    >{{ selectedItem.package_type }} -
                    {{ selectedItem.package_seq_type }}</span
                  >
                </div>
                <div
                  v-if="selectedType === 'library_sequence' && selectedItem.seq"
                  class="py-1"
                >
                  <div class="card">
                    <div class="card-header text-dark">Sequence</div>
                    <div class="card-body">
                      <div class="py-1 small text-monospace text-dark">
                        {{ selectedItem.seq }}
                      </div>
                      <div class="py-1 font-italic text-dark">
                        {{ selectedItem.seq.length }}
                      </div>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                </div>
                <div class="py-1">
                  <div class="card">
                    <div class="card-header text-dark">Description</div>
                    <div class="card-body">
                      <div class="py-1 small font-italic text-dark">
                        {{ selectedItem.desc }}
                      </div>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                </div>
                <div v-if="selectedType === 'package'" class="py-1">
                  <div v-if="selectedItem.comps" class="card">
                    <div class="card-header text-dark">Components</div>
                    <div class="card-body">
                      <div class="list-group">
                        <div
                          class="list-group-item text-wrap"
                          v-for="comp in selectedItem.comps"
                          :key="comp.index"
                        >
                          <div>
                            <span class="mr-1 small text-secondary"
                              >OLAB ID:</span
                            >
                            <span class="mr-3 font-italic text-dark">{{
                              comp.olab_id
                            }}</span>
                            <span
                              v-if="comp.name"
                              class="mr-1 small text-secondary"
                              >Name:</span
                            >
                            <span
                              v-if="comp.name"
                              class="mr-3 font-italic text-dark"
                              >{{ comp.name }}</span
                            >
                            <span
                              v-if="comp.locus_tag"
                              class="mr-1 small text-secondary"
                              >Locus Tag:</span
                            >
                            <span
                              v-if="comp.locus_tag"
                              class="mr-3 font-italic text-dark"
                              >{{ comp.locus_tag }}</span
                            >
                            <span
                              v-if="comp.old_locus_tag"
                              class="mr-1 small text-secondary"
                              >Old Locus Tag:</span
                            >
                            <span
                              v-if="comp.old_locus_tag"
                              class="mr-3 font-italic text-dark"
                              >{{ comp.old_locus_tag }}</span
                            >
                            <span class="mr-1 small text-secondary"
                              >Use As:</span
                            >
                            <span class="mr-3 font-italic text-dark">{{
                              comp.use_seq_as
                            }}</span>
                            <span
                              v-if="comp.length"
                              class="mr-1 small text-secondary"
                              >Length:</span
                            >
                            <span
                              v-if="comp.length"
                              class="mr-3 font-italic text-dark"
                              >{{ comp.length }}</span
                            >
                            <!-- <span class="mr-1 small text-secondary">Quantity:</span>
                            <span class="mr-3 font-italic text-dark">{{ comp.qty }}</span> -->
                          </div>
                          <div>
                            <span class="mr-1 small text-secondary"
                              >Sequence:</span
                            >
                            <span class="mr-3 text-monospace text-dark">{{
                              comp.seq
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                </div>
              </div>
              <!-- .modal-body -->
              <div class="modal-footer">
                <button
                  v-if="selectedCart || selectedPackage"
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  v-on:click="handleAddToComps(selectedItem, selectedType)"
                >
                  Add
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Back
                </button>
              </div>
              <!-- .modal-footer -->
            </div>
            <!-- .modal-content -->
          </div>
          <!-- .modal-dialog -->
        </div>
        <!-- .modal fade #selectAddItem -->

        <div v-if="selectedType === 'cart'" class="col-3 mx-1">
          <OlabCartSVGGen :comps="sid.comps" :fillColor="'compdb'" />
        </div>

        <div v-if="selectedType === 'package'" class="col-3 mx-1">
          <OlabPackageSVGGen
            :type="sid.package_type"
            :seqType="sid.package_seq_type"
            :comps="sid.comps"
            :fillColor="'compdb'"
          />
        </div>

        <div v-if="selectedType === 'library_sequence'" class="col-7 mx-1">
          <OlabSequenceSVGGen
            v-if="sid && sid.gene_stats"
            :numA="sid.gene_stats.num_a"
            :numC="sid.gene_stats.num_c"
            :numG="sid.gene_stats.num_g"
            :numT="sid.gene_stats.num_t"
            :shortSeq="sid.gene_stats.short_seq"
            :len="sid.gene_stats.len"
          />
        </div>

        <div class="col text-truncate">
          <a
            class="h5 text-info"
            data-toggle="modal"
            href="#itemDetailInfo"
            v-on:click="registerItem(sid)"
            data-backdrop="static"
            data-keyboard="false"
            >{{ sid.olab_id }}</a
          >

          <div
            v-if="selectedItem != null"
            class="modal fade"
            id="itemDetailInfo"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    OLAB ID:
                    <span class="h5 text-dark">{{ selectedItem.olab_id }}</span>
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <!-- .modal-header -->
                <div class="modal-body">
                  <div class="text-wrap">
                    <span class="font-italic mr-1">Name:</span>
                    <span class="h5 text-dark">{{ selectedItem.name }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Sequence Origin:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.seq_origin
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'cart'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Creator:</span>
                    <span class="h5 text-dark">{{ selectedItem.creator }}</span>
                  </div>
                  <div v-if="selectedType === 'cart'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Project:</span>
                    <span class="h5 text-dark">{{ printProjectInfo }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Source:</span>
                    <span class="h5 text-dark">{{ selectedItem.source }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Creator:</span>
                    <span class="h5 text-dark">{{ selectedItem.creator }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Library ID:</span>
                    <span class="h5 text-dark">{{ printLibraryInfo }}</span>
                  </div>
                  <div v-if="selectedType === 'package'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Package Type:</span>
                    <span class="h5 text-dark"
                      >{{ selectedItem.package_type }} -
                      {{ selectedItem.package_seq_type }}</span
                    >
                  </div>
                  <div v-if="selectedType === 'library_sequence'" class="py-1">
                    <div class="card">
                      <div class="card-header text-dark">Sequence</div>
                      <div v-if="selectedItem.seq" class="card-body">
                        <div
                          class="py-1 small text-monospace mr-1 text-dark text-wrap"
                        >
                          {{ selectedItem.seq }}
                        </div>
                        <div v-if="selectedItem.seq" class="py-1">
                          <span class="font-italic small mr-1">Length:</span>
                          <span class="h5 small text-dark">{{
                            selectedItem.seq.length
                          }}</span>
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </div>
                  <div class="py1">
                    <div class="card">
                      <div class="card-header text-dark">Description</div>
                      <div class="card-body">
                        <div class="py-1 small font-italic text-dark text-wrap">
                          {{ selectedItem.desc }}
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </div>
                  <div
                    v-if="selectedType === 'cart' || selectedType === 'package'"
                    class="py-1"
                  >
                    <div v-if="selectedItem.comps" class="card">
                      <div class="card-header text-dark">Components</div>
                      <div class="card-body">
                        <div class="list-group">
                          <div
                            class="list-group-item text-wrap"
                            v-for="comp in selectedItem.comps"
                            :key="comp.index"
                          >
                            <div>
                              <span class="mr-1 small text-secondary"
                                >OLAB ID:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.olab_id
                              }}</span>
                              <span
                                v-if="comp.name"
                                class="mr-1 small text-secondary"
                                >Name:</span
                              >
                              <span
                                v-if="comp.name"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.name }}</span
                              >
                              <span
                                v-if="comp.locus_tag"
                                class="mr-1 small text-secondary"
                                >Locus Tag:</span
                              >
                              <span
                                v-if="comp.locus_tag"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.locus_tag }}</span
                              >
                              <span
                                v-if="comp.old_locus_tag"
                                class="mr-1 small text-secondary"
                                >Old Locus Tag:</span
                              >
                              <span
                                v-if="comp.old_locus_tag"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.old_locus_tag }}</span
                              >
                              <span class="mr-1 small text-secondary"
                                >Use As:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.use_seq_as
                              }}</span>
                              <span
                                v-if="comp.length"
                                class="mr-1 small text-secondary"
                                >Length:</span
                              >
                              <span
                                v-if="comp.length"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.length }}</span
                              >
                              <span v-if="selectedType === 'cart'">
                                <span class="mr-1 small text-secondary"
                                  >Quantity:</span
                                >
                                <span class="mr-3 font-italic text-dark">{{
                                  comp.qty
                                }}</span>
                              </span>
                            </div>
                            <div v-if="selectedType === 'package'" class="mt-1">
                              <span class="mr-1 small text-secondary"
                                >Sequence:</span
                              >
                              <span
                                class="mr-3 small text-monospace text-dark"
                                >{{ comp.seq }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </div>
                </div>
                <!-- .modal-body -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
                <!-- .modal-footer -->
              </div>
              <!-- .modal-content -->
            </div>
            <!-- .modal-dialog .modal-lg-->
          </div>
          <!-- .modal fade #itemDetailInfo -->

          <div class="h5 mt-2">{{ sid.name }}</div>
          <div v-if="selectedType === 'library_sequence'" class="h6">
            {{ sid.seq_origin }}
          </div>
          <div class="h6">{{ sid.creator }}</div>
          <div
            v-if="selectedType === 'cart' || selectedType === 'package'"
            class="h5"
          >
            <button
              type="button"
              class="btn btn-info"
              data-toggle="modal"
              data-target="#cloneItem"
              v-on:click="preCloneItem(sid)"
              data-backdrop="static"
              data-keyboard="false"
            >
              Clone {{ selectedTypeName }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="cloneItem">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Clone: {{ selectedTypeName }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- .modal-header -->
          <div class="modal-body">
            <form>
              <fieldset class="form-group">
                <!-- <legend>{{ selectedType }} Info</legend> -->
                <div class="form-group">
                  <label class="form-control-label font-italic">
                    <span>Name:</span>
                    <span class="small text-danger">*</span>
                  </label>
                  <input
                    class="form-control"
                    v-bind:class="item.getValidState(item.name)"
                    type="text"
                    v-model="item.name"
                  />
                  <!-- <div class="invalid-feedback">{{ invalidFB.name }}</div> -->
                </div>
                <div v-if="selectedType === 'cart'" class="form-group">
                  <label class="form-control-label font-italic">
                    <span>Project ID:</span>
                    <span class="small text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    v-bind:class="item.getValidState(item.project_id)"
                    v-model="item.project_id"
                  >
                    <option disabled value="null">Please select one</option>
                    <option v-for="pj in projects" :key="pj.olab_id"
                      >{{ pj.olab_id }}&nbsp; - &nbsp;{{ pj.name }}</option
                    >
                  </select>
                  <!-- <span>selected = {{item.project_id}}</span> -->
                </div>
                <div class="form-group">
                  <label class="form-control-label font-italic">Creator:</label>
                  <span class="ml-1">{{ item.creator }}</span>
                </div>
                <div v-if="selectedType === 'package'" class="form-group">
                  <span class="form-control-label font-italic mr-1"
                    >Package Type:</span
                  >
                  <span class="ml-1"
                    >{{ item.package_type }} - {{ item.package_seq_type }}</span
                  >
                </div>
                <div class="form-group">
                  <label class="form-control-label font-italic"
                    >Description:</label
                  >
                  <textarea class="form-control" v-model="item.desc"></textarea>
                </div>
                <div v-if="item.comps" class="card">
                  <div class="card-header text-dark">Components</div>
                  <div class="card-body">
                    <div class="list-group">
                      <div
                        class="list-group-item text-wrap"
                        v-for="comp in item.comps"
                        :key="comp.index"
                      >
                        <div>
                          <span class="mr-1 small text-secondary"
                            >OLAB ID:</span
                          >
                          <span class="mr-3 font-italic text-dark">{{
                            comp.olab_id
                          }}</span>
                          <span
                            v-if="comp.name"
                            class="mr-1 small text-secondary"
                            >Name:</span
                          >
                          <span
                            v-if="comp.name"
                            class="mr-3 font-italic text-dark"
                            >{{ comp.name }}</span
                          >
                          <span
                            v-if="comp.locus_tag"
                            class="mr-1 small text-secondary"
                            >Locus Tag:</span
                          >
                          <span
                            v-if="comp.locus_tag"
                            class="mr-3 font-italic text-dark"
                            >{{ comp.locus_tag }}</span
                          >
                          <span
                            v-if="comp.old_locus_tag"
                            class="mr-1 small text-secondary"
                            >Old Locus Tag:</span
                          >
                          <span
                            v-if="comp.old_locus_tag"
                            class="mr-3 font-italic text-dark"
                            >{{ comp.old_locus_tag }}</span
                          >
                          <span class="mr-1 small text-secondary">Use As:</span>
                          <span class="mr-3 font-italic text-dark">{{
                            comp.use_seq_as
                          }}</span>
                          <span
                            v-if="comp.length"
                            class="mr-1 small text-secondary"
                            >Length:</span
                          >
                          <span
                            v-if="comp.length"
                            class="mr-3 font-italic text-dark"
                            >{{ comp.length }}</span
                          >
                          <span v-if="selectedType === 'cart'">
                            <span class="mr-1 small text-secondary"
                              >Quantity:</span
                            >
                            <span class="mr-3 font-italic text-dark">{{
                              comp.qty
                            }}</span>
                          </span>
                        </div>
                        <div v-if="selectedType === 'package'" class="mt-1">
                          <span class="mr-1 small text-secondary"
                            >Sequence:</span
                          >
                          <span class="mr-3 small text-monospace text-dark">{{
                            comp.seq
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- .card-body -->
                </div>
                <!-- .card -->
              </fieldset>
              <!-- .form-group -->
            </form>
          </div>
          <!-- .modal-body -->

          <div class="modal-footer">
            <button
              type="button"
              v-bind:disabled="cloneIsDisabled == true"
              class="btn btn-primary"
              data-dismiss="modal"
              v-on:click="handleCloneItem(item)"
            >
              Clone
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
          <!-- .modal-footer -->
        </div>
        <!-- .modal-content -->
      </div>
      <!-- .modal-dialog .modal-lg-->
    </div>
    <!-- .modal fade cloneItem -->
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import OlabCartSVGGen from "@/components/OlabCartSVGGen";
import OlabPackageSVGGen from "@/components/OlabPackageSVGGen";
import OlabSequenceSVGGen from "@/components/OlabSequenceSVGGen";
import { OlabItem } from "../olab/olabitem.js";
import { OlabUtils } from "../olab/olabutils.js";
import _ from "lodash";

export default {
  name: "compdbitemlist",
  data: function() {
    return {
      selectedItem: null,
      invalidFB: OlabItem.getInvalidFeedbacks()
    };
  },
  props: [
    "user",
    "dbInfo",
    "projects",
    "strains",
    "libraries",
    "error",
    "selectedItems",
    "selectedType",
    "selectedTypeName",
    "item",
    "selectedCart",
    "selectedPackage",
    "cartIsFull",
    "packageIsFull"
  ],
  components: {
    FontAwesomeIcon,
    OlabCartSVGGen,
    OlabPackageSVGGen,
    OlabSequenceSVGGen
  },
  computed: {
    enablePackageAdd: function() {
      let pkgAddOK =
        !this.selectedCart &&
        this.selectedPackage &&
        this.selectedPackage.package_seq_type == "library_sequence" &&
        !this.packageIsFull &&
        this.selectedType === "library_sequence";
      return pkgAddOK;
    },
    cloneIsDisabled: function() {
      switch (this.selectedType) {
        case "cart":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator) ||
            !this.item.isValid(this.item.project_id)
          );
        // break;
        case "package":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator)
          );
        // break;
      }
      return false;
    },
    printProjectInfo: function() {
      return this.appendNameToLibrary(
        this.selectedItem.project_id,
        this.projects
      );
    },
    printLibraryInfo: function() {
      return this.appendNameToLibrary(
        this.selectedItem.library_id,
        this.libraries
      );
    }
  },
  filters: {
    convertCompToStrand: function(value) {
      // console.log("value = " + value + ", (value == true) = " +  (value == true));
      return value == "true" ? "-" : "+";
    }
  },
  methods: {
    notInPackage(sid, comps) {
      let result = true;
      OlabUtils.infoLog("sid.olab_id = " + sid.olab_id);
      OlabUtils.infoLog("comps.length = " + comps.length);
      comps.forEach(comp => {
        if (sid.olab_id == comp.olab_id) {
          OlabUtils.infoLog("sid == comp = " + (sid == comp));
          result = false;
        }
      });
      OlabUtils.infoLog("**** result = " + result);
      return result;
    },
    appendNameToLibrary: function(id, library) {
      if (library != null) {
        for (let i = 0; i < library.length; i++) {
          if (library[i].olab_id == id) {
            return library[i].olab_id + " - " + library[i].name;
          }
        }
      }
      return "";
    },
    preCloneItem: function(sid) {
      OlabUtils.infoLog("preCloneItem");
      this.selectedItem = sid;
      this.item.set(sid);
      if (sid.comps) {
        // Do a shallow clone of sid's comps
        this.item.comps = _.clone(sid.comps);
      }
      // initialize creator with user's email
      this.item.creator = this.user.email;

      if (sid.olab_type === "cart") {
        // Add project name
        this.item.project_id = this.appendNameToLibrary(
          this.item.project_id,
          this.projects
        );

        // Clean used count and set available count for each comp
        this.item.comps.forEach(comp => {
          comp.used_count = 0;
          comp.available_count = comp.qty;
        });
        // Clone doesn't copy construct box array
        this.item.cstbs = [];
      }

      // Reset name and olab_id
      this.item.name = "";
      this.item.olab_id = "";
    },
    handleCloneItem: function(item) {
      OlabUtils.infoLog(
        "handleCloneItem: item = " +
          item.olab_id +
          ", name = " +
          item.name +
          ", olab_type = " +
          item.olab_type
      );
      this.$emit("doCloneItem", item);
    },
    registerItem: function(item) {
      this.selectedItem = item;
      // OlabUtils.infoLog("registerItem: item = " + item);
      // Copy data to this.item so that v-model for edit item.
      this.item.set(item);
    },
    handleSelectCart: function(ct) {
      OlabUtils.infoLog("handleSelectCart: ct = " + ct.olab_id);
      this.$emit("doSelectCart", ct);
    },
    handleAddToComps: function(item, type) {
      OlabUtils.infoLog(
        "handleAddToComps: item = " + item.olab_id + ", type = " + type
      );
      OlabUtils.infoLog(
        "handleAddToComps: item.library_id = " + item.library_id
      );
      let useSeqAs;
      if (type === "library_sequence") {
        // Add the follow field for comps use
        item.length = item.seq.length;

        switch (item.library_id) {
          case "LG":
            useSeqAs = "gene";
            break;
          case "LH":
            useSeqAs = "arm";
            break;
          case "LP":
            useSeqAs = "promoter";
            break;
          case "LR":
            useSeqAs = "rbs";
            break;
          case "LT":
            useSeqAs = "terminator";
            break;
          case "LV":
            useSeqAs = "plasmid";
            break;
          case "LW":
            useSeqAs = "pgst";
            break;
          default:
            // Set default as "gene"
            useSeqAs = "gene";
            break;
        }
      } else if (type === "package") {
        // Add the follow field for comps use
        useSeqAs = item.package_type;
      } else {
        useSeqAs = "UNKNOWN";
      }
      OlabUtils.infoLog("handleAddToComps: useSeqAs = " + useSeqAs);
      this.$emit("doAddToComps", { item: item, useSeqAs: useSeqAs });
    },
    handleSelectPackage: function(pkg) {
      OlabUtils.infoLog("handleSelectPackage: pkg = " + pkg.olab_id);
      this.$emit("doSelectPackage", pkg);
    }
  }
};
</script>
